/**
 * @param type string | undefined | null, the string could be 'Elektriciteit' or 'Gas'
 * @returns 'Stroom' in case of 'Elektriciteit' otherwise it returns the input value.
 */
export const rewriteEnergyType = (type: string | undefined | null): string | undefined | null => {
  return type === 'Elektriciteit' ? 'Stroom' : type;
};
